/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-10-04T14:18:55+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-06T11:13:32+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getField} from 'react-redux-form/src';
import MBoxErrorMessages from './../components/MBoxErrorMessages';


function mapStateToProps(state, ownProps) {
  const formField = getField(state, ownProps.formModel);
  return {
    hasErrors: formField && !formField.valid,
    formField,
  };
}


/**
 * MDisplayFormError - …
**/
class MDisplayFormError extends Component {
  render() {
    const {
      formField,
      hasErrors,
      showErrors,
      message,
    } = this.props;

    const show = (typeof showErrors === 'function') ? showErrors(formField) : showErrors;

    const errorEl = (!(hasErrors && show)) ? null : (
            <MBoxErrorMessages
              errors={{formHasError: message}}
            />
        );

    return (
      <div className="m-display m-display-form-error">
        {errorEl}
      </div>
    );
  }
}
MDisplayFormError.propTypes = {
  /**
     * formModel of the form
     */
  formModel: PropTypes.string.isRequired,
  /**
     * show errors for input fields on ...
     * default to true
     * see: https://davidkpiano.github.io/react-redux-form/docs/api/Errors.html#show
     */
  showErrors: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]).isRequired,
  /**
     * message to be displayed when the form is invalid
     */
  message: PropTypes.string.isRequired,
  /**
     * form field data
     */
  formField: PropTypes.object.isRequired, // passed by redux
  /**
     * if the form has errors
     */
  hasErrors: PropTypes.bool.isRequired, // passed by redux
};
MDisplayFormError.defaultProps = {
  showErrors: true,
};
export default connect(mapStateToProps)(MDisplayFormError);

